module.exports = __webpack_public_path__ + "static/media/tray16.983cbab0.png";